import React, { useEffect, useState } from "react";

// Effet machine à écrire : écrit, pause, efface, phrase suivante
export default function Typewriter({ words, typeSpeed = 45, deleteSpeed = 22, pause = 1600, className = "" }) {
  const [i, setI] = useState(0);
  const [text, setText] = useState("");
  const [del, setDel] = useState(false);

  useEffect(() => {
    const full = words[i % words.length];
    let t;
    if (!del && text === full) t = setTimeout(() => setDel(true), pause);
    else if (del && text === "") { setDel(false); setI((x) => x + 1); }
    else t = setTimeout(() => setText(del ? full.slice(0, text.length - 1) : full.slice(0, text.length + 1)), del ? deleteSpeed : typeSpeed);
    return () => clearTimeout(t);
  }, [text, del, i, words, typeSpeed, deleteSpeed, pause]);

  const longest = words.reduce((a, b) => (b.length > a.length ? b : a), "");
  return (
    <span className={`inline-grid ${className}`} data-testid="typewriter" aria-label={words[i % words.length]}>
      <span aria-hidden="true" className="invisible col-start-1 row-start-1">{longest}<span className="inline-block w-[3px] ml-1" /></span>
      <span className="col-start-1 row-start-1">
        {text}
        <span className="inline-block w-[3px] h-[0.9em] bg-[#d9895a] ml-1 align-[-0.08em] animate-[caret_1s_steps(1)_infinite]" />
      </span>
    </span>
  );
}
